import Cookies from 'js-cookie';

const getAccessToken = (): string | undefined => Cookies.get('jwt_access_token');

export default getAccessToken;
